import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { GridMaxHeight, RowHeightsUserLogs } from '../../typings/grid';

import './ExpandableCell.css';

export interface ExpandableProps {
    onHeightCalculated: (maxHeight: GridMaxHeight) => void;
    onHeightRecalculated: () => void;
    rowIndex: number;
    isExpanded: boolean;
    maxHeight?: number;
    maxHeightCleared: boolean;
    canExpand: boolean;
}

// высоту паддингов надо учитывать при обсчете высоты ячейки
export const expandablePaddings = 40;

export abstract class ExpandableCell<
    TProps extends ExpandableProps
> extends React.PureComponent<TProps> {
    protected cell: React.ReactInstance | null;

    componentDidMount() {
        const { onHeightCalculated, rowIndex } = this.props;
        const height = this.getCellMaxHeight();
        onHeightCalculated({ rowIndex: rowIndex, maxHeight: height });
    }

    componentDidUpdate(prevProps: TProps) {
        const {
            onHeightCalculated,
            isExpanded,
            rowIndex,
            maxHeight,
            maxHeightCleared,
            onHeightRecalculated
        } = this.props;
        if (maxHeight === undefined) {
            const height = this.getCellMaxHeight();
            onHeightCalculated({ rowIndex: rowIndex, maxHeight: height });
            // максимальные высоты хранятся отдельно (не в сторе), чтобы их расчет не триггерил дополнительную перерисовку
            // однако если мы меняем ширину и при этом на экране есть расхлопнутый ряд, у которого должна поменяться высота расхлопа,
            // то триггерить перерисовку необходимо
            if (maxHeightCleared && isExpanded) {
                onHeightRecalculated();
            }
        }
    }

    protected getCellMaxHeight(): number {
        return this.calculateHeight();
    }

    protected abstract getContent(): React.ReactNode;

    protected calculateHeight(): number {
        let height = RowHeightsUserLogs.expanded;

        const { canExpand } = this.props;
        if (!canExpand) {
            return RowHeightsUserLogs.default;
        }

        // смотрим высоту ячейки
        if (this.cell !== null) {
            const cellNode = this.cell as Element;
            // разворачиваем ряды
            cellNode.classList.toggle(
                Bem.cls('expandable-cell', 'tryout-height')
            );

            height = cellNode.clientHeight + expandablePaddings;

            // сворачиваем ряды
            cellNode.classList.toggle(
                Bem.cls('expandable-cell', 'tryout-height')
            );
        }

        return Math.max(RowHeightsUserLogs.expanded, height);
    }

    render() {
        const { canExpand, isExpanded } = this.props;
        return (
            <div
                className={classNames(
                    Bem.cls('expandable-cell'),
                    canExpand ? Bem.cls('expandable-cell', 'short') : '',
                    canExpand && !isExpanded
                        ? Bem.cls('expandable-cell', 'luxury')
                        : ''
                )}
            >
                {this.getContent()}
            </div>
        );
    }
}
